import styled, { css } from 'styled-components'

export const StyledInput = styled.input`
    color: ${({ theme }) => theme['gray-800']} !important;
    background-color: ${({ theme }) => theme['gray-0']} !important;
    border: 1px solid ${({ theme }) => theme['gray-400']} !important;
    margin: 16px !important;
    width: calc(100% - 32px) !important;
    border-radius: 3px;
    box-shadow: none;
    outline: none;
`

export const StyledHorizontalRow = styled.hr`
    margin: 0 16px 16px 16px;
    border-color: ${({ theme }) => theme['gray-1000']};
`

export const FoundedListContainer = styled.div`
    cursor: pointer;
    padding: 0 16px;
`

export const FoundedList = styled.div`
    width: 100%;
    height: 60px;
    display: flex;
    flex-wrap: nowrap;
    color: ${({ theme }) => theme['gray-1000']};
`

const getColor = (escId: string): string => {
    if (escId.startsWith('thr')) {
        return '#3866B1'
    }

    if (escId.startsWith('cnq')) {
        return '#8768A3'
    }

    if (escId.startsWith('esc')) {
        return '#F9E47F'
    }

    return '#606A80'
}

const getTextColor = (escId: string): string => {
    if (escId.startsWith('esc')) {
        return '#000'
    }

    return '#fff'
}

export const FoundedTitleContainer = styled.div<{ idx: number; length: number; escId: string; prevEscId: string }>`
    padding: 5px;

    position: relative;
    height: 60px;
    width: 250px;
    flex-shrink: 0;
    overflow: hidden;
    background: ${({ escId }) => getColor(escId)};
    color: ${({ escId }) => getTextColor(escId)};
    font-family: ${({ theme }) => theme['font-bold']};

    > div {
        height: 50px;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        line-height: calc(48px / 3);
        overflow: hidden;
        text-overflow: ellipsis;
    }

    ${({ prevEscId, idx }) =>
        idx === 0
            ? css`
                  border-top-left-radius: 5px;
                  border-bottom-left-radius: 5px;
              `
            : css`
                  padding-left: 40px;

                  ::before {
                      background: ${getColor(prevEscId)};
                      position: absolute;
                      left: -22px;
                      top: calc(50% - 22px);
                      content: '';
                      height: 44px;
                      width: 44px;
                      transform: rotate(45deg);
                  }
              `}

    ${({ idx, length }) =>
        idx === length &&
        css`
            border-top-right-radius: 5px;
            border-bottom-right-radius: 5px;
        `}
`
